export var BankMandateLisMapper = function (data) {
    var list = data.bankList.map(function (x) {
        return {
            bnkAcNo: x.accountNumber,
            bnkNm: x.bankName,
            brn: x.branch,
            ifscCode: x.ifscCode,
            def: x.default,
        };
    });
    return {
        data: {
            lst: list,
            aldMndTypes: data.allowedMandates,
            type: undefined,
        },
    };
};
